module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/listagem-cursos-pagina/banner/banner.component.html
// module id = ./src/app/shared/listagem-cursos-pagina/banner/banner.component.html
// module chunks = main